var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 18.4204H16.8713C16.7453 14.7875 14.2667 11.6949 10.7384 10.7904L8.63916 12.8517C8.52637 12.9625 8.34525 12.9625 8.23247 12.8517L6.13322 10.7904C2.60466 11.6949 0.126281 14.7875 0 18.4204ZM8.43581 9.38582C5.96419 9.38582 3.95325 7.37488 3.95325 4.90297C3.95325 2.43135 5.96419 0.42041 8.43581 0.42041C10.9074 0.42041 12.9184 2.43135 12.9184 4.90297C12.9184 7.37488 10.9074 9.38582 8.43581 9.38582Z",
    fill: "#344054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.005d5fac35a1379d4058fa9a3de78990.svg";
export { ForwardRef as ReactComponent };